
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tours-destinations",
      function () {
        return require("private-next-pages/tours-destinations.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tours-destinations"])
      });
    }
  